import wrongSlide_bg from'../images/wrongSlide_bg.gif'
import classroomMainCut_bg_presentation1 from'../images/classroomMainCut_bg_presentation1.png'
import classroomMainCut_bg_presentation2 from'../images/classroomMainCut_bg_presentation2.png'
import classroomMainCut_bg_presentation4 from'../images/classroomMainCut_bg_presentation4.png'
import classroomMainCut_bg_presentation6 from'../images/classroomMainCut_bg_presentation6.png'
import ryderTakingOffJumper from'../images/ryderTakingOffJumper.png'
import ryderBendingOver4 from'../images/ryderBendingOver4.gif'
import ryderCloserLook from'../images/ryderCloserLook.png'
import stacyShowingPussy from'../images/stacyShowingPussy.png'

const gallery = [
  [0, "Chapter 1", 0],
  [classroomMainCut_bg_presentation1, "0", 1],
  [classroomMainCut_bg_presentation2, "0", 2],
  [wrongSlide_bg, "0", 3],
  [ryderTakingOffJumper, "0", 4],
  [ryderBendingOver4, "0", 5],
  [classroomMainCut_bg_presentation4, "0", 6],
  [ryderCloserLook, "0", 7],
  [classroomMainCut_bg_presentation6, "0", 8],
  [stacyShowingPussy, "0", 9],
];

export default gallery;
